import { useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import styles from './Body.module.scss';
import { UnOrderedList } from '../../../faq/helpers';
import {
  DescriptionDetails,
  ImageBackground,
  ListItem,
  MobileContent,
} from './BodyHelpers';
import Image from 'next/image';
import {
  painReliefBody,
  zenFactorBody,
  goFactorBody,
  zFactorBody,
} from '../../../../../src/images';

export default function Body({ id, productType }) {
  const listItems = [];

  const imageList = {
    REL: painReliefBody,
    ZEN: zenFactorBody,
    GOF: goFactorBody,
    ZFA: zFactorBody,
  };
  const colorList = {
    REL: '#004152',
    ZEN: '#392B6D',
    GOF: '#365024',
    ZFA: '#1D4475',
  };
  const painReliefTitle = 'When You Feel the Difference, You Know It Works';
  const zenFactorTitle = 'When You Feel the Difference, You Know It Works';
  const painReliefItems = [
    {
      title: 'Begin Your Journey',
      description: {
        text: UnOrderedList(
          'Start with 1 packet taken three times daily. Then reduce to 2 or even 1 packet daily as pain reduction is achieved.  Then continue taking Relief Factor daily to stay out of pain.',
          [,]
        ),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Your Transformation',
      description: {
        text: UnOrderedList(
          'In just a few weeks, many of our customers reduce or even eliminate their daily pain. In extreme circumstances, some people take a few months to achieve their pain relief.',
          []
        ),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Reclaim Your Life',
      description: {
        text: UnOrderedList(
          'Remember what it was like to live your life without pain, doing what you want to do without concerns about pain. Rekindle a lost passion, improve relationships strained by pain, or simply regain the simple joy of pain-free days.',
          []
        ),
        details: '',
      },
      isDisabled: false,
    },
  ];
  const zenFactorItems = [
    {
      title: "Improve Your Body's Response to Stress",
      description: {
        text: UnOrderedList(null, [
          'Zen Factor helps your body recover from tension and anxiety.',
          'Diminishes your fight or flight response to stress.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Reduce Anxiety',
      description: {
        text: UnOrderedList(null, [
          'Enhances your mood, mental clarity, creativity, and overall well-being.',
          'Supports brain function, memory, and mental focus.',
          'Handle whatever life throws your way, worry-free.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Find Your Serenity',
      description: {
        text: UnOrderedList(null, [
          'Be at peace and centered.',
          'A calm focus.',
          'Improve every day by leaving stress and anxiety behind.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: '100% Drug-free, Non-addictive',
      description: {
        text: UnOrderedList(null, [
          'A safe, all-natural dietary supplement that leaves you clear and focused.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
  ];
  const goFactorItems = [
    {
      title: 'High-Quality Energy',
      description: {
        text: UnOrderedList(null, [
          'An energetic life is your best life.',
          'Find motivation throughout your day and quickly boost your mood to make your best decisions.',
          'Pursue your goals, increase your endurance, and improve your resilience.',
          'Tackle challenging activities and projects with confidence.',
          'High-quality energy for your work and hobbies, friends and family.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Better than Energy Drinks',
      description: {
        text: UnOrderedList(null, [
          'Easy to carry and consume.',
          'Costs significantly less per dose.',
          'Customize your dose.',
          'Take it when you need it.',
          'Fast-acting.',
          'No added sugar or calories.',
          "Won't disrupt sleep.",
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Boost Your Mental and Physical Performance.',
      description: {
        text: UnOrderedList(null, [
          'Contains minimal caffeine to fuel you, without artificial ingredients or calories.',
          'Enhances focus, concentration, productivity, and motivation.',
          'Enjoy the activities you love and swiftly complete your projects.',
          'Power through your studies and stay focused for class or long drives.',
          'Taurine is currently being researched as a potential anti-aging compound.',
          'Energize yourself with nutrients to recover fast and rebuild your body.',
          'Enhances your workout performance and utilizes your body’s stored fat.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: '100% Drug-free, Non-addictive',
      description: {
        text: UnOrderedList(null, [
          'A safe, fast-acting dietary supplement that leaves you energized, without the jitters or crash.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
  ];
  const zFactorItems = [
    {
      title: 'Fall Asleep Quickly.',
      description: {
        text: UnOrderedList(null, [
          'Relax and calm your mind.',
          'Reset your sleep and wake cycle.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Sleep Soundly',
      description: {
        text: UnOrderedList(null, ['Sleep through the night.']),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: 'Wake Up Rested and Restored',
      description: {
        text: UnOrderedList(null, [
          'Enhance mental clarity.',
          'Increase productivity.',
          'Improve your relationships.',
          'Boost your immune system.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
    {
      title: '100% Drug-free, Non-addictive',
      description: {
        text: UnOrderedList(null, [
          'A safe, all-natural dietary supplement that supports your ability to sleep.',
          'Gives you peace of mind.',
        ]),
        details: '',
      },
      isDisabled: false,
    },
  ];

  if (productType == 'REL') {
    listItems.push(...painReliefItems);
  }
  if (productType == 'ZEN') {
    listItems.push(...zenFactorItems);
  }
  if (productType == 'GOF') {
    listItems.push(...goFactorItems);
  }
  if (productType == 'ZFA') {
    listItems.push(...zFactorItems);
  }

  const isTablet = useMediaQuery('(max-width: 1024px)');
  const [listIdx, setListIdx] = useState(0);
  const [selectedItem, setSelectedItem] = useState(listItems[0]);

  const StyledBackground = styled('div')(({ theme }) => ({
    backgroundImage: `radial-gradient(
      at bottom center,
      #d9efaf -70%,
      ${colorList[productType]} 30%,
      transparent
    ),
    radial-gradient(at top left, #9cd4ea -75%, ${colorList[productType]} 40%, ${colorList[productType]} 30%)`,
    [theme.breakpoints.down('lg')]: {
      backgroundImage: `radial-gradient(
        at top left,
        #9cd4ea -75%,
        ${colorList[productType]} 40%,
        ${colorList[productType]} 30%
      )`,
    },
  }));

  const StyledMobContainer = styled('div')(({ theme }) => ({
    backgroundColor: `${colorList[productType]}`,
  }));
  const onListItemClick = (idx) => {
    setListIdx(idx);
    if (!listItems[idx].isDisabled) {
      setSelectedItem(listItems[idx]);
    }
  };

  const handleNext = () => {
    const currentIdx = (listIdx + 1) % listItems.length;
    onListItemClick(currentIdx);
  };

  const handlePrev = () => {
    const currentIdx = (listIdx - 1 + listItems.length) % listItems.length;
    onListItemClick(currentIdx);
  };

  return (
    <StyledBackground className={styles.bodyModuleExtender} id={id}>
      <div className={styles.bodyModuleContainer}>
        {isTablet && <div className={styles.backgroundGradient} />}
        <div className={`${styles.innerWrapper} ${styles.paddingSides}`}>
          <div className={styles.centeredContent}>
            <span className={styles.mainTitle}>
              {productType == 'REL' ? painReliefTitle : zenFactorTitle}
            </span>
          </div>
        </div>
        {!isTablet && (
          <div className={styles.contentContainer}>
            <div
              className={`${styles.contentInnerContainer} ${styles.paddingSides}`}
            >
              <div className={styles.list}>
                {listItems.map((item, idx) => (
                  <span
                    key={item.title}
                    onClick={() => onListItemClick(idx)}
                    onMouseOver={() => onListItemClick(idx)}
                    style={{
                      cursor: item.isDisabled ? 'auto' : 'pointer',
                      opacity: idx == listIdx ? 1 : 0.6,
                    }}
                    className={styles.listItem}
                  >
                    <ListItem idx={idx} title={item.title} />
                  </span>
                ))}
              </div>

              <DescriptionDetails
                text={selectedItem?.description?.text}
                details={selectedItem?.description?.details}
              />
            </div>
          </div>
        )}

        {!isTablet && (
          <div className={styles.listItemImageContainer}>
            <ImageBackground
              imageComponent={
                <Image
                  src={imageList[productType]}
                  priority
                  placeholder="empty"
                  objectFit="contain"
                  layout="fill"
                />
              }
            />
          </div>
        )}

        {isTablet && (
          <div>
            <div className={styles.tabImageContainer}>
              <ImageBackground
                imageComponent={
                  <Image
                    src={imageList[productType]}
                    priority
                    placeholder="empty"
                    objectFit="contain"
                    layout="fill"
                  />
                }
              />
            </div>

            <StyledMobContainer className={styles.mobileContentContainer}>
              <MobileContent
                onNext={handleNext}
                onPrev={handlePrev}
                selectedItem={selectedItem}
                currentIdx={listIdx}
                listItems={listItems ?? []}
              />
            </StyledMobContainer>
          </div>
        )}
      </div>
    </StyledBackground>
  );
}
